import AccordionController from "@/controllers/accordion_controller"
import { viewItemListEvent } from "@/helpers/ga4_helper"
import { register } from "@/helpers/stimulus"
import { loadBackgroundImages } from "@/helpers/image_loader"

loadBackgroundImages()

const setupStimulus = (): void => {
  register("accordion", AccordionController)
}

setupStimulus()

// TODO[GA4]: Refactor `gift_of_spa` model/decorator so we can populate `items`
viewItemListEvent("Gift of Spa Vouchers", "gift_of_spa_vouchers", "Spa Gifts", [])
